import { PaginationReturn } from '@common/types/service';
import { contactFormSchema } from '@softwareIntegrator/schemas/SoftwareIntegratorFormSchema';
import { ISoftwareIntegratorDto, TSoftwareExpertise } from '@softwareIntegrator/types/softwareIntegrator';
import { InferType } from 'yup';
import { api } from '../../../services/api';

const softwareIntegratorApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getSoftwareIntegrators: builder.query<
            PaginationReturn<ISoftwareIntegratorDto>,
            Partial<{ search: string; domain_experience: TSoftwareExpertise }>
        >({
            query: (params) => {
                const search_name_or_country = params.search;
                const domain_experience = params.domain_experience;
                return {
                    url: 'public/software-integrators/',
                    params: { search_name_or_country, domain_experience },
                };
            },
        }),
        submitContactForm: builder.mutation<
            void,
            InferType<typeof contactFormSchema> & { software_integrator?: string }
        >({
            query: (formData) => ({
                url: 'public/software-integrators/support/',
                method: 'POST',
                body: formData,
            }),
        }),
    }),
});

export const { useGetSoftwareIntegratorsQuery, useSubmitContactFormMutation } = softwareIntegratorApi;
